import { environment } from 'src/environments/environment';

// Solo estas rutas están excluidas de requerir x-signature
const excludedRoutes: string[] = [
  `${environment.apiUrl}docs`,
  `${environment.apiUrl}sitemap`,
  `${environment.apiUrl}not-found`,
  `${environment.apiUrl}auth/`
];

export const shouldExclude = (url: string): boolean => {
  return excludedRoutes.some(route => url.startsWith(route));
};